module.exports = __webpack_public_path__ + "media/images/soar/instagram_logo-7c0e42ef2119c574cbf5f05b1854aa01.png";